/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Share_AudioInputs */

const en_dialog_share_audio = /** @type {(inputs: Dialog_Share_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share this audio with a friend?`)
};

const es_dialog_share_audio = /** @type {(inputs: Dialog_Share_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Compartir este audio con un amigo?`)
};

/**
* | output |
* | --- |
* | "Share this audio with a friend?" |
*
* @param {Dialog_Share_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_share_audio = /** @type {((inputs?: Dialog_Share_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Share_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_share_audio(inputs)
	return en_dialog_share_audio(inputs)
});